import React from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BZLogo from "../../components/BZLogo";
import { TwMainLayout } from "../../components/tailwind";
import { useLocalStorage } from "../../hooks";
import { loadingState } from "../../redux/reducers/loadingReducer";
import SignUpForm from "./SignUpForm";
import { useTranslation } from "react-i18next";
import I18nLanguageDropdown from "../../components/I18nLanguageDropdown";

export default function SignUp({ }) {

  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loadingReduxState = useSelector(loadingState);
  const [userToken, setUserToken] = useLocalStorage("userToken");
  const [loading, setLoading] = React.useState(false);

  if ((userToken)) {
    // navigate("/home/dashboard");
    window.location.href = "/";
  }

  return (
    <TwMainLayout fullScreen={true} checkSession={false}>
      <div className="min-h-screen bg-white flex flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="fixed top-5 right-5">
          <I18nLanguageDropdown />
        </div>
        <div className="sm:mx-auto sm:w-full sm:max-w-md flex flex-col gap-5">
          <BZLogo className="mx-auto" />
          {!userToken && (<div className={"flex flex-col justify-center items-center gap-5 md:gap-8"}>
            <h2 className="text-center text-2xl md:text-3xl font-bold tracking-tight">
              {t("signup.signupTitle")}
            </h2>
          </div>)}
        </div>

        {!userToken && (<div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <SignUpForm
            navigation={navigate}
            setLoading={setLoading}
          />
        </div>)}
      </div>
    </TwMainLayout>)

}
